import { Button } from "@/components/ui/button";
import { 
  Phone, 
  Mail, 
  CheckCircle2, 
  Paintbrush, 
  Car, 
  Wrench, 
  Sparkles,
  Layers,
  Shield,
  CircleDot
} from "lucide-react";

const PHONE_NUMBER = "tel:+493916357115";
const EMAIL = "mailto:info@lackzentrum-wilke.com";

// Professional high-quality images
const IMAGE_PAINT_BOOTH = "https://images.pexels.com/photos/8470881/pexels-photo-8470881.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900&fit=crop";
const IMAGE_WORKSHOP = "https://images.pexels.com/photos/30250199/pexels-photo-30250199.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900&fit=crop";
const IMAGE_BODY_REPAIR = "https://images.pexels.com/photos/5233262/pexels-photo-5233262.jpeg?auto=compress&cs=tinysrgb&w=1200&h=900&fit=crop";
const IMAGE_DETAILING = "https://images.unsplash.com/photo-1620584899131-a5ff5f8fbb03?auto=format&fit=crop&w=1200&q=80";

export const ServiceDetails = () => {
  return (
    <div>
      {/* Lackierung Detail */}
      <section id="lackierung-detail" className="py-16 lg:py-24 bg-background">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="lg:order-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Paintbrush className="h-5 w-5 text-primary" />
                </div>
                <span className="text-sm font-semibold text-primary uppercase tracking-wider">
                  Professionelle Lackierung mit modernster Technik
                </span>
              </div>
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-6">
                Fahrzeuglackierung in Magdeburg
              </h2>
              <p className="text-muted-foreground leading-relaxed mb-8">
                Zu den Voraussetzungen einer brillanten Lackierung zählen digitale Farbmessgeräte, 
                computergesteuerte Lackmischanlagen und entsprechende Lackier- bzw. Trocknungsanlagen. 
                Eine Kunst, die wir beherrschen.
              </p>
              <div className="mb-8">
                <h3 className="font-display text-lg font-semibold text-foreground mb-4">Unser Prozess:</h3>
                <ul className="space-y-3">
                  {["Digitale Farbtonmessung mit Spektral-Photometer", "Computergesteuerte Lackmischung", "Professionelle Grundierung", "Lackauftrag in moderner Kabine", "Hochwertiges Finish"].map((step, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <CheckCircle2 className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                      <span className="text-muted-foreground">{step}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button variant="primary" size="lg" asChild className="gap-2">
                  <a href={PHONE_NUMBER}><Phone className="h-4 w-4" />Jetzt anrufen</a>
                </Button>
                <Button variant="outline" size="lg" asChild className="gap-2">
                  <a href={EMAIL}><Mail className="h-4 w-4" />E-Mail senden</a>
                </Button>
              </div>
            </div>
            <div className="lg:order-2">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img src={IMAGE_PAINT_BOOTH} alt="Fahrzeuglackierung" className="w-full h-auto object-cover aspect-[4/3]" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Karosseriebau Detail */}
      <section id="karosseriebau-detail" className="py-16 lg:py-24 bg-secondary/30">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="lg:order-2">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Car className="h-5 w-5 text-primary" />
                </div>
                <span className="text-sm font-semibold text-primary uppercase tracking-wider">
                  Zuverlässigkeit aus Meisterhand
                </span>
              </div>
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-6">
                Karosseriebau
              </h2>
              <p className="text-muted-foreground leading-relaxed mb-8">
                Zuverlässigkeit, Professionalität und bester Service. Der Einsatz modernster Technik 
                vermeidet Strapazen für Ihr Portemonnaie. Familiäre Werte: Vertrauen und Zusammenhalt.
              </p>
              <div className="mb-8">
                <h3 className="font-display text-lg font-semibold text-foreground mb-4">Unser Prozess:</h3>
                <ul className="space-y-3">
                  {["Umfassende Schadensanalyse", "Professionelle Richtarbeiten", "Fachgerechtes Ausbeulen", "Präzise Schweißarbeiten", "Austausch von Karosserieteilen"].map((step, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <CheckCircle2 className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                      <span className="text-muted-foreground">{step}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button variant="primary" size="lg" asChild className="gap-2">
                  <a href={PHONE_NUMBER}><Phone className="h-4 w-4" />Beratung anrufen</a>
                </Button>
                <Button variant="outline" size="lg" asChild className="gap-2">
                  <a href={EMAIL}><Mail className="h-4 w-4" />Anfrage senden</a>
                </Button>
              </div>
            </div>
            <div className="lg:order-1">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img src={IMAGE_WORKSHOP} alt="Karosseriebau" className="w-full h-auto object-cover aspect-[4/3]" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Unfallinstandsetzung Detail */}
      <section id="unfall-detail" className="py-16 lg:py-24 bg-background">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="lg:order-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Wrench className="h-5 w-5 text-primary" />
                </div>
                <span className="text-sm font-semibold text-primary uppercase tracking-wider">
                  Komplette Unfallabwicklung aus einer Hand
                </span>
              </div>
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-6">
                Karosserie- und Unfallinstandsetzung
              </h2>
              <p className="text-muted-foreground leading-relaxed mb-8">
                Preisbewusste und fachgerechte Instandsetzung Ihres Unfallwagens. 
                Moderne Richtbank und Laser-Achsvermessungsanlage für schwere Schäden.
              </p>
              <div className="mb-8">
                <h3 className="font-display text-lg font-semibold text-foreground mb-4">Unser Prozess:</h3>
                <ul className="space-y-3">
                  {["Detaillierte Schadenanalyse", "Kosteneinschätzung und Beratung", "Unterstützung bei Versicherungsabwicklung", "Glasreparatur und Scheibentausch", "Laser-Achsvermessung"].map((step, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <CheckCircle2 className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                      <span className="text-muted-foreground">{step}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button variant="primary" size="lg" asChild className="gap-2">
                  <a href={PHONE_NUMBER}><Phone className="h-4 w-4" />Schaden melden</a>
                </Button>
                <Button variant="outline" size="lg" asChild className="gap-2">
                  <a href={EMAIL}><Mail className="h-4 w-4" />Bilder senden</a>
                </Button>
              </div>
            </div>
            <div className="lg:order-2">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img src={IMAGE_BODY_REPAIR} alt="Unfallinstandsetzung" className="w-full h-auto object-cover aspect-[4/3]" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Spot-Repair Detail */}
      <section id="spot-repair-detail" className="py-16 lg:py-24 bg-secondary/30">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div className="lg:order-2">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Sparkles className="h-5 w-5 text-primary" />
                </div>
                <span className="text-sm font-semibold text-primary uppercase tracking-wider">
                  Schnelle Lösung für kleine Schäden
                </span>
              </div>
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-6">
                Spot-Repair / Smart-Repair
              </h2>
              <p className="text-muted-foreground leading-relaxed mb-8">
                Ideale Lösung für kleine Kratzer, Dellen und Parkrempler. 
                Besonders vor der Leasingrückgabe schnell und kostengünstig.
              </p>
              <div className="mb-8">
                <h3 className="font-display text-lg font-semibold text-foreground mb-4">Unser Prozess:</h3>
                <ul className="space-y-3">
                  {["Begutachtung des Schadens", "Punktgenaue Reparatur", "Minimaler Lackauftrag", "Schnelle Trocknung", "Perfektes Finish"].map((step, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <CheckCircle2 className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                      <span className="text-muted-foreground">{step}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button variant="primary" size="lg" asChild className="gap-2">
                  <a href={PHONE_NUMBER}><Phone className="h-4 w-4" />Preisinfo einholen</a>
                </Button>
                <Button variant="outline" size="lg" asChild className="gap-2">
                  <a href={EMAIL}><Mail className="h-4 w-4" />Anfrage senden</a>
                </Button>
              </div>
            </div>
            <div className="lg:order-1">
              <div className="rounded-2xl overflow-hidden shadow-xl">
                <img src={IMAGE_DETAILING} alt="Spot-Repair" className="w-full h-auto object-cover aspect-[4/3]" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Zusatzleistungen */}
      <section id="zusatzleistungen" className="py-16 lg:py-24 bg-background">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
              Zusatzleistungen
            </span>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-6">
              Weitere Services für Ihr Fahrzeug
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Neben unseren Kernleistungen bieten wir Ihnen weitere Services, 
              um Ihr Fahrzeug rundum zu betreuen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="bg-card rounded-xl p-6 border border-border/50 hover:border-primary/30 transition-colors duration-300">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <Layers className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-display text-xl font-semibold text-card-foreground mb-3">
                Kunststoffreparaturen
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                Fachgerechte Reparatur von Stoßfängern, Spiegeln und Verkleidungen.
              </p>
            </div>

            <div className="bg-card rounded-xl p-6 border border-border/50 hover:border-primary/30 transition-colors duration-300">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <Shield className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-display text-xl font-semibold text-card-foreground mb-3">
                Glas- und Scheibenreparatur
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                Professionelle Steinschlagreparatur und Scheibentausch.
              </p>
            </div>

            <div className="bg-card rounded-xl p-6 border border-border/50 hover:border-primary/30 transition-colors duration-300">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <CircleDot className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-display text-xl font-semibold text-card-foreground mb-3">
                Felgenaufbereitung
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                Aufbereitung und Instandsetzung von Leichtmetallfelgen.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="primary" size="lg" asChild className="gap-2">
              <a href={PHONE_NUMBER}><Phone className="h-4 w-4" />Jetzt beraten lassen</a>
            </Button>
            <Button variant="outline" size="lg" asChild className="gap-2">
              <a href={EMAIL}><Mail className="h-4 w-4" />E-Mail-Anfrage senden</a>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetails;
